import react from "react";

import { useTheme, Box } from "@mui/material";
import AlertBallIcon from "./AlertBallIcon";

const BellIcon = ({ seen = false, errorColor }) => {
  
  const theme = useTheme();

	return (
		<Box
      sx={{
        position: "relative",
        height: 'fit-content',
        width: 'fit-content',
			}}
		>
			<AlertBallIcon show={!seen}/>
      <svg
				width="25"
				height="30"
				viewBox="0 0 25 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12.5 30C14.2188 30 15.625 28.6154 15.625 26.9231H9.375C9.375 28.6154 10.7812 30 12.5 30ZM21.875 20.7692V13.0769C21.875 8.35385 19.3281 4.4 14.8438 3.35385V2.30769C14.8438 1.03077 13.7969 0 12.5 0C11.2031 0 10.1562 1.03077 10.1562 2.30769V3.35385C5.6875 4.4 3.125 8.33846 3.125 13.0769V20.7692L0 23.8462V25.3846H25V23.8462L21.875 20.7692ZM18.75 22.3077H6.25V13.0769C6.25 9.26154 8.60938 6.15385 12.5 6.15385C16.3906 6.15385 18.75 9.26154 18.75 13.0769V22.3077Z"
					fill= {errorColor || "#A3A4A3"}
				/>
			</svg>
		</Box>
	);
};

export default BellIcon;
